import React, { useState } from 'react'
import { TouchableOpacity, UIManager, LayoutAnimation } from 'react-native'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import PropTypes from 'prop-types'

import VFText from '../VfText'

import styles from './ShowMoreText.Styles'

UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true)

const CustomLayoutAnimation = {
  duration: 150,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
}

function ShowMoreText({
  text,
  showMoreText,
  showLessText,
}) {
  const [isExpanded, setExpanded] = useState(false)
  const toogleExpanded = () => {
    LayoutAnimation.configureNext(CustomLayoutAnimation)
    setExpanded(prev => !prev)
  }

  const theme = useTheme()

  return (
    <>
      {isExpanded && <VFText i18nKey={text} style={styles.text} color={theme.colors.textColor} />}
      <TouchableOpacity onPress={toogleExpanded} style={styles.toogleContainer(theme)}>
        <VFText i18nKey={isExpanded ? showLessText : showMoreText} color={Colors.vfRed} style={styles.toggleText} />
      </TouchableOpacity>
    </>
  )
}

ShowMoreText.propTypes = {
  text: PropTypes.string,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
}

export default ShowMoreText
